import {
	Toolbar,
	Magnification,
	Navigation,
	LinkAnnotation,
	TextSelection,
	TextSearch,
	FormFields,
	Annotation,
	ThumbnailView
} from "@syncfusion/ej2-vue-pdfviewer";

import { isMobileUA } from "../helpers/mobile";
  
export function usePdfViewer() {
	const PdfViewer = [
		Toolbar,
		Magnification,
		Navigation,
		LinkAnnotation,
		TextSelection,
		TextSearch,
		FormFields,
		Annotation
	];
  
	if (!isMobileUA()) {
		PdfViewer.push(ThumbnailView);
	}
  
	return { PdfViewer };
}